$(function () {
    search_trigger = $('.header-search__trigger');
    search_box = $('.header-search__form');

    search_trigger.click(function () {
        $(this).toggleClass('header-search__trigger--active');
        search_box.toggleClass('header-search__form--active');
        $('#searchTerm').focus();
        // body.toggleClass('body--overlay');
    });

    search_box.click(function (event) {
        event.stopPropagation();
    });

    $(document).click(function (e) {
        if (!$(search_trigger, search_box).is(e.target)) {
            search_trigger.removeClass('header-search__trigger--active');
            search_box.removeClass('header-search__form--active');
            if ($('body').hasClass('body--overlay')) {
                $('body').removeClass('body--overlay');
            }
        }
    });
});